import { Injectable, signal } from '@angular/core';
import { ActionMenuItem } from '@/share/template/button/action-menu';

@Injectable({ providedIn: 'root' })
export class ActionMenuService {
    isOpen = signal(false);
    x = signal(0);
    y = signal(0);
    items = signal<ActionMenuItem[]>([]);
    private callback?: (action: string) => void;

    open(x: number, y: number, items: ActionMenuItem[], callback: (action: string) => void): void {
        this.x.set(x);
        this.y.set(y);
        this.items.set(items);
        this.callback = callback;
        this.isOpen.set(true);
    }

    close(): void {
        this.isOpen.set(false);
    }

    emit(action: string): void {
        const cb = this.callback;
        this.callback = undefined;
        this.isOpen.set(false); // close first
        // ✅ call cb after everything is settled
        Promise.resolve().then(() => cb?.(action));
    }
}
